import React, { useEffect } from 'react';

const STYLE_ID = 'bn-engaging-loader-styles';

function ensureStyles() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = `
@keyframes bnSpin { to { transform: rotate(360deg); } }
@keyframes bnDotPulse {
  0%, 80%, 100% { opacity: .25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-2px); }
}
`;
  document.head.appendChild(el);
}

export function Spinner({ size = 14, color = '#44403c', thickness = 2 }) {
  useEffect(() => { ensureStyles(); }, []);
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        border: `${thickness}px solid rgba(68,64,60,0.18)`,
        borderTopColor: color,
        display: 'inline-block',
        animation: 'bnSpin 0.9s linear infinite',
        boxSizing: 'border-box',
        flex: '0 0 auto'
      }}
    />
  );
}

export function LoadingDots({ color = '#78716c' }) {
  useEffect(() => { ensureStyles(); }, []);
  const dot = (delay) => ({
    width: 5,
    height: 5,
    borderRadius: 999,
    background: color,
    display: 'inline-block',
    animation: 'bnDotPulse 1.1s ease-in-out infinite',
    animationDelay: delay
  });
  return (
    <span aria-hidden="true" style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
      <span style={dot('0ms')} />
      <span style={dot('150ms')} />
      <span style={dot('300ms')} />
    </span>
  );
}

export function LoaderInline({ label = 'Working', color = '#44403c' }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color }}>
      <Spinner size={14} color={color} />
      <span style={{ fontWeight: 700 }}>{label}</span>
      <LoadingDots />
    </span>
  );
}

